import React, { Component } from 'react'
import OverlayItems from './OverlayItems'
import {
  getSubscriptionPlans,
  getInvisiblePlans
} from "~/redux/user/subscription";
import { getLocalizedVal } from '~/tools/localization/helpers';
import { groupBy,isObject } from 'lodash'
import './style.css'

class Overlay extends Component {
  state = { 
    selected: 0, 
    items: [], 
    plans: [], 
    planSelected:0 
  }

  componentDidMount() {
    let { content } = this.props
    let ids = { video: content.gist.id, series: content.seriesId, season: content.seasonId }
    let pricing = Overlay.formatPricing(content.pricing, ids, content.gist.title || content.gist.description);
    const type = this.props.model || this.props.content.pricing.type
      if (type && type.includes('SVOD')) {
      if (!window.sessionStorage.getItem('plans')) {
        getSubscriptionPlans().then(plans => {
          this.setState({ plans })
        })
      } else {
        getInvisiblePlans().then(plans => {
          this.setState({ plans })
        })
      }
    }

    this.setState({ type, items: pricing })
  }

  static formatPricing(pricing, id, title) {
    function firstLetterUppercase(str) {
      return str.charAt(0).toUpperCase().concat(str.substring(1))
    }

    const items = []
    const contentTitle = window.settings.internalName.includes('supercrosslive') ? getLocalizedVal(window.settings,'genericMessages', 'singleEventLabel') : `${title} |`

    Object.keys(pricing).forEach(option => {
      if (pricing[option] && option !== 'type' && option !== 'currency') {
        const optionKeys = Object.keys(pricing[option]);
        optionKeys.forEach(key => {
          if (pricing[option][key]) {
            let obj = {};
            obj.key = key.toUpperCase()
            obj.videoID = id.video;
            obj.contentID = id.content;
            if (isObject(id.video)) {
              id = id.video
              obj.videoID = (id.video || id.items.join(',')) || null
              obj.contentID = id.content
            }
            obj.seriesId = id.series || null 
            obj.seasonId = id.season || null
            obj.option = firstLetterUppercase(option);
            obj.price = pricing[option][key];
            let name = (obj.option.toLowerCase() == 'rent' ? getLocalizedVal(window.settings,'genericMessages', 'rentOverlayLabel') : (obj.option.toLowerCase() == 'purchase' ? getLocalizedVal(window.settings,'genericMessages', 'purchaseOverlayLabel') : obj.option));
            //obj.description = TVODMap[option](title);
            obj.name = `${contentTitle} ${name} $${obj.price}`;
            items.push(obj);
          }
        });
      }
    })
    return items
  }

  selected(i){
    this.setState({
      selected: i
    })
  }

  planSelected = i => {
    this.setState({
      planSelected: i
    })
  }

  getTitleBasedOnPricingOption = () => {
    var sortedListByOptions = groupBy(this.state.items, 'option');
    if(Object.keys(sortedListByOptions).includes('Purchase') && Object.keys(sortedListByOptions).includes('Rent')) {
      return getLocalizedVal(window.settings,'genericMessages', 'rentPurchaseOverlayLabel');
    } else if(Object.keys(sortedListByOptions).includes('Purchase')) {
      return getLocalizedVal(window.settings,'genericMessages', 'purchaseOverlayLabel');
    } else if(Object.keys(sortedListByOptions).includes('Rent')) {
      return getLocalizedVal(window.settings,'genericMessages', 'rentOverlayLabel');
    }
  }

  render() {
    const { plans, items, type } = this.state;
    const label = this.getTitleBasedOnPricingOption();
    // const label = type && type === 'TVOD' ? getLocalizedVal('genericMessages', 'purchaseOverlayLabel') : getLocalizedVal('genericMessages','rentPurchaseOverlayLabel')
    const isSVOD = type && type === 'SVOD'
    const modelType = this.props.model || this.props.content.pricing.type
    return (
      <div className={`overlay-video-container ${plans.length > 0 && !isSVOD && 'subscriptions'}`}>
        { !isSVOD && <OverlayItems title={label} items={items} {...this.props} type = {modelType}/> }
        { plans.length > 0 &&
          <OverlayItems 
            title={getLocalizedVal(window.settings,'navigation.settings','primaryCta.ctaText')}
            type = {modelType}
            items={plans} 
            subscriptionPlans={true}
            {...this.props} 
          />
        }
      </div>
    )
  }

}

export default Overlay 
